import React from 'react';
import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const TutorSearchNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/tutor/edit/1`;
  return <NavigationModel redirectUrl={redirectUrl} title="Tutor Search" navigationTo={'Old Portal'} />;
};

export default TutorSearchNavigation;
